import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { loadSection } from "../../services/contentSource";
import aboutFallback from "../../data/home/about.json";

const AboutSection: React.FC = () => {
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    loadSection("about", aboutFallback as any).then(({ data: main }) => setData(main));
  }, []);

  if (!data) return null;

  return (
    <section className="about-area mx-about-revamp" id="about">
      <div className="container mx-container">
        <div className="mx-about-header">
          <div className="mx-hero-badge">
            <span className="mx-hero-badge-icon">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M12 8v8M8 12h8"></path>
              </svg>
            </span>
            <span>01. WHO WE ARE</span>
          </div>

          <h2 className="mx-about-title">
            WE BUILD DIGITAL PRODUCTS THAT THINK, ADAPT, AND DELIVER!
          </h2>
        </div>

        <div className="mx-about-grid">
          {/* Left Column: Narrative, Action, and Twin Metric Cards */}
          <div className="mx-about-content">
            <p className="mx-about-lede">
              Today’s consumers and forward-thinking enterprises don't make decisions blindly. They explore.
              They compare. At MindSyncX, we engineer intelligent digital ecosystems and production AI architectures
              that ensure your brand and systems show up — beautifully, boldly, and with purpose — exactly where it matters.
            </p>

            <div className="mx-about-actions">
              <Link to="/about" className="mx-hero-btn-primary">
                <span>Explore MindSyncX</span>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </Link>
            </div>

            {/* Twin Stat Cards */}
            <div className="mx-about-stats-row">
              <div className="mx-about-stat-card">
                <div className="mx-about-stat-number">50+</div>
                <div className="mx-about-stat-title">Deployments &amp; Systems</div>
                <div className="mx-about-stat-desc">
                  High-growth startups and visionary brands scaling with MindSyncX intelligent architectures.
                </div>
              </div>

              <div className="mx-about-stat-card mx-about-stat-card-highlight">
                <div className="mx-about-stat-number">
                  10<span className="mx-about-stat-x">x</span>
                </div>
                <div className="mx-about-stat-title">Faster Execution Velocity</div>
                <div className="mx-about-stat-desc">
                  Make your business grow exponentially with our dedicated team of AI experts.
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: High-Res AI Engineering Lab Visual with HUD Overlays */}
          <div className="mx-about-visual-column">
            <div className="mx-about-visual-card">
              <img
                src="/assets/imgs/about/about-engineers-showcase.jpg"
                alt="MindSyncX Engineers developing intelligent digital products"
                className="mx-about-card-img"
                loading="lazy"
                decoding="async"
              />

              {/* Floating Glassmorphic HUD Overlays */}
              <div className="mx-about-hud-top-left">
                <div className="mx-about-hud-label">AI PRODUCT ARCHITECTURE</div>
                <div className="mx-about-hud-val">Multi-Agent &amp; Vision Systems</div>
              </div>

              <div className="mx-about-hud-top-right">
                <span className="mx-about-hud-pill">
                  <span className="mx-about-dot-pulse"></span>
                  PRODUCTION READY
                </span>
              </div>

              <div className="mx-about-hud-bottom">
                <div className="mx-about-hud-quote-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                  </svg>
                </div>
                <div className="mx-about-hud-quote-text">
                  Make your business grow exponentially with our team of AI Experts. We’ll help you scale every system we build.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
